import { takeLatest, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import {
  VALIDATE_JIRA_TICKET,
  VALIDATE_JIRA_TICKET_SUCCESS,
  VALIDATE_JIRA_TICKET_ERROR,
} from '../../actions.js';
import apiCall from '../../../apiCall.js';

function* validateJiraTicket({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/utility-request/validate-jira`,
      method: 'GET',
      params: { ticket_id: payload.ticketId },
      headers: filteredHeaders,
    });

    if (response.status === 200) {
      yield put({ type: VALIDATE_JIRA_TICKET_SUCCESS, payload: response?.data });
    } else {
      yield put({ type: VALIDATE_JIRA_TICKET_ERROR, payload: response?.response?.data?.message || 'Invalid Jira ticket' });
    }
  } catch (error) {
    yield put({ type: VALIDATE_JIRA_TICKET_ERROR, payload: 'Invalid Jira ticket' });
  }
}

export function* watchValidateJiraTicket() {
  yield takeLatest(VALIDATE_JIRA_TICKET, validateJiraTicket);
}

function* validateJiraTicketSaga() {
  yield all([fork(watchValidateJiraTicket)]);
}

export default validateJiraTicketSaga;
